export enum Enforce {
  always = 'always',
  never = 'never',
  hours = 'hours',
}
